<template>
  <div>

    <pageTable ref="table"
               :tableTitle="tableColumn"
               :showPage="false"
               :showSearchForm="false"
               tableApi="admin/zhongqi/getStations"
    >

      <template v-slot:otherBtn>
        <!--<FormItem>
          <Button type="primary" @click="notifyAll">全部推送</Button>
        </FormItem>-->
        <FormItem>
          <Button type="primary" @click="exportData">导出</Button>
        </FormItem>
      </template>
    </pageTable>


  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  export default {
    name: "card",
    components:{pageTable},
    data() {
      return {
        tableColumn: [
          {type: 'index',width: 60, align: 'center'},
          {title: 'ID',key: 'station_id',align: "center",render:(h,params)=>{
              return h('div',[
                h('p',params.row.station_id),
                h('Tag',{props:{color:'orange'}},params.row.platform),
              ])
            }},
          {title: '名称',key: 'gas_name',align: "center"},
          {title: '省',key: 'province_name',align: "center"},
          {title: '市',key: 'city_name',align: "center"},
          {title: '区',key: 'county_name',align: "center"},
          {title: '对外价格',key: 'price',align: "center"},
          {title: '对内价格',key: 'price2',align: "center"},
          {title: '站点价格',key: 'price2',align: "center",render:(h,params)=>{
            return h('div',[
              h('p',`油机价: ${params.row.station_price}`),
              h('p',`挂牌价: ${params.row.ndrc_price}`),
            ])
            }},
          {title: '车队价格',key: 'company_price',align: "center",render:(h,params)=>{
             return  h('Input',{
                style:{width:'60px',marginRight:'5px'},
                props:{value:params.row.company_price,size:'small'},
                on:{
                  input:(val)=>{
                    this.$set(params.row,'company_price',val)
                  }
                }
              })
            }},
          {title: '油机价',key: 'station_price',align: "center",render:(h,params)=>{
              return  h('Input',{
                style:{width:'60px',marginRight:'5px'},
                props:{value:params.row.new_retail_prices,size:'small'},
                on:{
                  input:(val)=>{
                    this.$set(params.row,'new_retail_prices',val)
                  }
                }
              })
            }},
          {title: '挂牌价',key: 'ndrc_price',align: "center",render:(h,params)=>{
             return  h('Input',{
                style:{width:'60px',marginRight:'5px'},
                props:{value:params.row.ndrc_price,size:'small'},
                on:{
                  input:(val)=>{
                    this.$set(params.row,'ndrc_price',val)
                  }
                }
              })
            }},
          {title: '操作',align: "center",width:100,render:(h,params)=>{
              return h('div',[
                h('Button',{
                  props: {type: 'primary', size: 'small'},
                  on: {click: () => {this.edit(params.row)}}
                }, '确定'),
              ])
            }},
        ],
        tableData: [],
      }
    },
    methods: {
      async edit(info){
        let  params={
          station_id:info.station_id,
          price:info.company_price,
          ndrc_price:info.ndrc_price,
          new_retail_prices:info.new_retail_prices,
        }
        let res = await this.$commonFun.postProxy('admin/zhongqi/editPrice',params);
        this.$commonFun.dealApiResult(res,()=>{
          this.$commonFun.successTip(res.msg,()=>{
            this.$refs.table.getLists();
          })
        })
      },
      async notifyAll(){
        let res = await this.$commonFun.postProxy('admin/zhongqi/doNotify',{});
        this.$commonFun.dealApiResult(res)
      },
      async exportData(){
        this.$commonFun.downFileByPost('admin/zhongqi/downStation',this.uploadFormData)
      }
    },
    mounted() {
    },
  }
</script>

<style scoped>

</style>
